<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="toolbar-button" @click="jobSeekerDrawer = true">
        <img :src="require('@/assets/img/icons/home.svg')" />
      </ion-button>
    </ion-buttons>
    <ion-title>
      <img v-if="isAustralia" :src="require('@/assets/img/toolbar-logo.png')" :alt="$filters.appName()">
      <img v-if="isUS" :src="require('@/assets/img/us/toolbar-logo-us.png')" :alt="$filters.appName()">
    </ion-title>
    <ion-buttons slot="end">
        <ion-button class="notifications_button toolbar-button" @click="notifications">
          <!-- <i class="locumate_icons locumate_icon-notification_bell"></i> -->
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.1168 12.0748L15.2834 10.6915C15.1084 10.3832 14.9501 9.79984 14.9501 9.45817V7.34984C14.9501 5.3915 13.8001 3.69984 12.1418 2.90817C11.7084 2.1415 10.9084 1.6665 9.99178 1.6665C9.08345 1.6665 8.26678 2.15817 7.83345 2.93317C6.20845 3.7415 5.08345 5.4165 5.08345 7.34984V9.45817C5.08345 9.79984 4.92511 10.3832 4.75012 10.6832L3.90845 12.0748C3.57512 12.6332 3.50012 13.2498 3.70845 13.8165C3.90845 14.3748 4.38345 14.8082 5.00012 15.0165C6.61678 15.5665 8.31678 15.8332 10.0168 15.8332C11.7168 15.8332 13.4168 15.5665 15.0334 15.0248C15.6168 14.8332 16.0668 14.3915 16.2834 13.8165C16.5001 13.2415 16.4418 12.6082 16.1168 12.0748Z" fill="black"/>
            <path d="M12.3582 16.6748C12.0082 17.6415 11.0832 18.3332 9.9999 18.3332C9.34157 18.3332 8.69157 18.0665 8.23324 17.5915C7.96657 17.3415 7.76657 17.0082 7.6499 16.6665C7.75824 16.6832 7.86657 16.6915 7.98324 16.7082C8.1749 16.7332 8.3749 16.7582 8.5749 16.7748C9.0499 16.8165 9.53324 16.8415 10.0166 16.8415C10.4916 16.8415 10.9666 16.8165 11.4332 16.7748C11.6082 16.7582 11.7832 16.7498 11.9499 16.7248C12.0832 16.7082 12.2166 16.6915 12.3582 16.6748Z" fill="black"/>
          </svg>
          <el-badge is-dot class="item" v-if="unreadNotifications"></el-badge>
        </ion-button>
      </ion-buttons>
  </ion-toolbar>
    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="setting-item">
                <div class="setting-item__icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M10 9.99996C12.3012 9.99996 14.1667 8.13448 14.1667 5.83329C14.1667 3.53211 12.3012 1.66663 10 1.66663C7.69885 1.66663 5.83337 3.53211 5.83337 5.83329C5.83337 8.13448 7.69885 9.99996 10 9.99996Z"
                            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path
                            d="M16.0083 13.1167L13.0583 16.0667C12.9416 16.1834 12.8333 16.4 12.8083 16.5584L12.6499 17.6833C12.5916 18.0917 12.875 18.375 13.2833 18.3167L14.4083 18.1583C14.5666 18.1333 14.7916 18.025 14.9 17.9084L17.8499 14.9584C18.3583 14.45 18.5999 13.8583 17.8499 13.1083C17.1083 12.3667 16.5166 12.6083 16.0083 13.1167Z"
                            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M15.5833 13.5416C15.8333 14.4416 16.5332 15.1416 17.4332 15.3916"
                            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M2.84167 18.3333C2.84167 15.1083 6.05003 12.5 10 12.5C10.8667 12.5 11.7 12.625 12.475 12.8583"
                            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>

                </div>
                <div class="setting-item__content" @click="links.changeBasicProfileJobSeeker">
                    <div class="setting-item__title">
                        Account
                    </div>
                    <div class="setting-item__description">
                        Update your account settings
                    </div>
                </div>
                <div class="setting-item__link">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.42505 16.5999L12.8584 11.1666C13.5 10.5249 13.5 9.4749 12.8584 8.83324L7.42505 3.3999"
                            stroke="rgb(var(--locumate-clr-gray))" stroke-width="1.5" stroke-miterlimit="10"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                </div>
            </div>



            <div class="setting-item">
                <div class="setting-item__icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12.4993 18.9582H7.49935C2.97435 18.9582 1.04102 17.0248 1.04102 12.4998V7.49984C1.04102 2.97484 2.97435 1.0415 7.49935 1.0415H11.666C12.0077 1.0415 12.291 1.32484 12.291 1.6665C12.291 2.00817 12.0077 2.2915 11.666 2.2915H7.49935C3.65768 2.2915 2.29102 3.65817 2.29102 7.49984V12.4998C2.29102 16.3415 3.65768 17.7082 7.49935 17.7082H12.4993C16.341 17.7082 17.7077 16.3415 17.7077 12.4998V8.33317C17.7077 7.9915 17.991 7.70817 18.3327 7.70817C18.6743 7.70817 18.9577 7.9915 18.9577 8.33317V12.4998C18.9577 17.0248 17.0243 18.9582 12.4993 18.9582Z"
                            fill="rgb(var(--locumate-primary-color))" />
                        <path
                            d="M18.3327 8.9584H14.9993C12.1493 8.9584 11.041 7.85007 11.041 5.00007V1.66674C11.041 1.41674 11.191 1.18341 11.4243 1.09174C11.6577 0.991739 11.9243 1.05007 12.1077 1.22507L18.7743 7.89174C18.9493 8.06674 19.0077 8.34174 18.9077 8.57507C18.8077 8.8084 18.5827 8.9584 18.3327 8.9584ZM12.291 3.17507V5.00007C12.291 7.15007 12.8493 7.70841 14.9993 7.70841H16.8243L12.291 3.17507Z"
                            fill="rgb(var(--locumate-primary-color))" />
                        <path
                            d="M10.834 11.4585H5.83398C5.49232 11.4585 5.20898 11.1752 5.20898 10.8335C5.20898 10.4918 5.49232 10.2085 5.83398 10.2085H10.834C11.1757 10.2085 11.459 10.4918 11.459 10.8335C11.459 11.1752 11.1757 11.4585 10.834 11.4585Z"
                            fill="rgb(var(--locumate-primary-color))" />
                        <path
                            d="M9.16732 14.7915H5.83398C5.49232 14.7915 5.20898 14.5082 5.20898 14.1665C5.20898 13.8248 5.49232 13.5415 5.83398 13.5415H9.16732C9.50898 13.5415 9.79232 13.8248 9.79232 14.1665C9.79232 14.5082 9.50898 14.7915 9.16732 14.7915Z"
                            fill="rgb(var(--locumate-primary-color))" />
                    </svg>

                </div>
                <div class="setting-item__content" @click="links.goToTermsAndConditions">
                    <div class="setting-item__title">
                        Terms and Conditions
                    </div>
                    <div class="setting-item__description">
                        Read terms and conditions
                    </div>
                </div>
                <div class="setting-item__link">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.42505 16.5999L12.8584 11.1666C13.5 10.5249 13.5 9.4749 12.8584 8.83324L7.42505 3.3999"
                            stroke="rgb(var(--locumate-clr-gray))" stroke-width="1.5" stroke-miterlimit="10"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                </div>
            </div>

            <div class="setting-item">
                <div class="setting-item__icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12.4993 10.7915H6.66602C6.32435 10.7915 6.04102 10.5082 6.04102 10.1665C6.04102 9.82484 6.32435 9.5415 6.66602 9.5415H12.4993C12.841 9.5415 13.1243 9.82484 13.1243 10.1665C13.1243 10.5082 12.841 10.7915 12.4993 10.7915Z"
                            fill="rgb(var(--locumate-primary-color))" />
                        <path
                            d="M10.316 14.125H6.66602C6.32435 14.125 6.04102 13.8417 6.04102 13.5C6.04102 13.1583 6.32435 12.875 6.66602 12.875H10.316C10.6577 12.875 10.941 13.1583 10.941 13.5C10.941 13.8417 10.6577 14.125 10.316 14.125Z"
                            fill="rgb(var(--locumate-primary-color))" />
                        <path
                            d="M11.666 5.62484H8.33268C7.53268 5.62484 6.04102 5.62484 6.04102 3.33317C6.04102 1.0415 7.53268 1.0415 8.33268 1.0415H11.666C12.466 1.0415 13.9577 1.0415 13.9577 3.33317C13.9577 4.13317 13.9577 5.62484 11.666 5.62484ZM8.33268 2.2915C7.50768 2.2915 7.29102 2.2915 7.29102 3.33317C7.29102 4.37484 7.50768 4.37484 8.33268 4.37484H11.666C12.7077 4.37484 12.7077 4.15817 12.7077 3.33317C12.7077 2.2915 12.491 2.2915 11.666 2.2915H8.33268Z"
                            fill="rgb(var(--locumate-primary-color))" />
                        <path
                            d="M12.5 18.9582H7.5C2.81667 18.9582 1.875 16.8082 1.875 13.3332V8.33319C1.875 4.5332 3.25 2.9082 6.63333 2.7332C6.96667 2.71653 7.275 2.97486 7.29167 3.32486C7.30833 3.67486 7.04167 3.9582 6.7 3.97486C4.33333 4.1082 3.125 4.81653 3.125 8.33319V13.3332C3.125 16.4165 3.73333 17.7082 7.5 17.7082H12.5C16.2667 17.7082 16.875 16.4165 16.875 13.3332V8.33319C16.875 4.81653 15.6667 4.1082 13.3 3.97486C12.9583 3.9582 12.6917 3.6582 12.7083 3.31653C12.725 2.97486 13.025 2.7082 13.3667 2.72486C16.75 2.9082 18.125 4.53319 18.125 8.32486V13.3249C18.125 16.8082 17.1833 18.9582 12.5 18.9582Z"
                            fill="rgb(var(--locumate-primary-color))" />
                    </svg>
                </div>
                <div class="setting-item__content" @click="links.goToPrivacyPolicy">
                    <div class="setting-item__title">
                        Privacy Policies
                    </div>
                    <div class="setting-item__description">
                        Read privacy policies
                    </div>
                </div>
                <div class="setting-item__link">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.42505 16.5999L12.8584 11.1666C13.5 10.5249 13.5 9.4749 12.8584 8.83324L7.42505 3.3999"
                            stroke="rgb(var(--locumate-clr-gray))" stroke-width="1.5" stroke-miterlimit="10"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                </div>
            </div>

            <div class="setting-item">
                <div class="setting-item__icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M18.3084 15.2751C18.3084 15.5751 18.2417 15.8834 18.1001 16.1834C17.9584 16.4834 17.7751 16.7667 17.5334 17.0334C17.1251 17.4834 16.6751 17.8084 16.1667 18.0167C15.6667 18.2251 15.1251 18.3334 14.5417 18.3334C13.6917 18.3334 12.7834 18.1334 11.8251 17.7251C10.8667 17.3167 9.90842 16.7667 8.95842 16.0751C8.00008 15.3751 7.09175 14.6001 6.22508 13.7417C5.36675 12.8751 4.59175 11.9667 3.90008 11.0167C3.21675 10.0667 2.66675 9.11675 2.26675 8.17508C1.86675 7.22508 1.66675 6.31675 1.66675 5.45008C1.66675 4.88341 1.76675 4.34175 1.96675 3.84175C2.16675 3.33341 2.48341 2.86675 2.92508 2.45008C3.45841 1.92508 4.04175 1.66675 4.65841 1.66675C4.89175 1.66675 5.12508 1.71675 5.33341 1.81675C5.55008 1.91675 5.74175 2.06675 5.89175 2.28341L7.82508 5.00841C7.97508 5.21675 8.08341 5.40841 8.15841 5.59175C8.23341 5.76675 8.27508 5.94175 8.27508 6.10008C8.27508 6.30008 8.21675 6.50008 8.10008 6.69175C7.99175 6.88341 7.83341 7.08341 7.63341 7.28341L7.00008 7.94175C6.90841 8.03341 6.86675 8.14175 6.86675 8.27508C6.86675 8.34175 6.87508 8.40008 6.89175 8.46675C6.91675 8.53341 6.94175 8.58341 6.95842 8.63341C7.10842 8.90841 7.36675 9.26675 7.73341 9.70008C8.10841 10.1334 8.50841 10.5751 8.94175 11.0167C9.39175 11.4584 9.82508 11.8667 10.2667 12.2417C10.7001 12.6084 11.0584 12.8584 11.3417 13.0084C11.3834 13.0251 11.4334 13.0501 11.4917 13.0751C11.5584 13.1001 11.6251 13.1084 11.7001 13.1084C11.8417 13.1084 11.9501 13.0584 12.0417 12.9667L12.6751 12.3417C12.8834 12.1334 13.0834 11.9751 13.2751 11.8751C13.4667 11.7584 13.6584 11.7001 13.8667 11.7001C14.0251 11.7001 14.1917 11.7334 14.3751 11.8084C14.5584 11.8834 14.7501 11.9917 14.9584 12.1334L17.7167 14.0917C17.9334 14.2417 18.0834 14.4167 18.1751 14.6251C18.2584 14.8334 18.3084 15.0417 18.3084 15.2751Z"
                            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" />
                        <path
                            d="M15.4167 7.50016C15.4167 7.00016 15.025 6.2335 14.4417 5.6085C13.9083 5.0335 13.2 4.5835 12.5 4.5835"
                            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M18.3333 7.50008C18.3333 4.27508 15.725 1.66675 12.5 1.66675"
                            stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="setting-item__content">

                    <a :href="supportLink" target="_blank" data-testid="support-btn">
                        <div class="setting-item__title"> Support</div>
                        <div class="setting-item__description">
                            Contact our Support team
                        </div>
                    </a>
                </div>
                <div class="setting-item__link">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.42505 16.5999L12.8584 11.1666C13.5 10.5249 13.5 9.4749 12.8584 8.83324L7.42505 3.3999"
                            stroke="rgb(var(--locumate-clr-gray))" stroke-width="1.5" stroke-miterlimit="10"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                </div>
            </div>
            <div class="setting-item">
                <div class="setting-item__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="22" height="22"
                        viewBox="0 0 256.000000 256.000000" preserveAspectRatio="xMidYMid meet">

                        <g transform="translate(0.000000,256.000000) scale(0.100000,-0.100000)" fill="#000000"
                            stroke="none">
                            <path
                                d="M1140 2205 l-121 -105 -235 0 c-143 0 -243 -4 -255 -10 -18 -10 -19 -24 -19 -223 l-1 -212 -129 -113 -130 -113 0 -577 c0 -436 3 -581 12 -590 14 -14 404 -17 426 -3 8 5 12 21 10 37 l-3 29 -153 3 c-100 2 -152 6 -150 13 2 6 111 143 243 305 l239 294 406 0 406 0 239 -295 c132 -162 241 -299 243 -305 3 -7 -186 -10 -592 -10 -585 0 -595 0 -606 -20 -8 -14 -8 -26 0 -40 11 -20 21 -20 663 -20 495 0 656 3 665 12 9 9 12 154 12 589 l0 578 -122 108 c-68 59 -126 112 -130 118 -4 5 -8 103 -8 217 0 195 -1 208 -19 218 -12 6 -112 10 -255 10 l-235 0 -121 105 c-67 58 -130 105 -140 105 -10 0 -73 -47 -140 -105z m205 -50 l60 -54 -125 0 -125 0 60 54 c33 30 62 55 65 55 3 0 32 -25 65 -55z m625 -529 l0 -384 -149 -111 -149 -111 -391 0 -391 0 -150 111 -150 111 0 384 0 384 690 0 690 0 0 -384z m-1460 -206 c0 -60 -3 -110 -6 -110 -4 0 -38 23 -76 51 l-69 51 43 37 c23 20 54 46 68 58 14 12 28 23 33 23 4 0 7 -49 7 -110z m1614 58 c34 -28 65 -55 69 -58 7 -7 -122 -110 -137 -110 -3 0 -6 50 -6 110 0 61 3 110 7 110 3 0 34 -23 67 -52z m-1562 -323 c123 -91 223 -170 223 -176 0 -12 -437 -557 -447 -558 -5 -1 -8 202 -8 449 0 248 2 450 5 450 2 0 105 -74 227 -165z m1668 -287 c0 -448 0 -452 -19 -433 -43 44 -441 540 -439 547 4 9 440 336 451 337 4 1 7 -203 7 -451z" fill="rgb(var(--locumate-primary-color))"/>
                            <path
                                d="M972 1868 c-8 -8 -12 -54 -12 -141 0 -157 -11 -186 -71 -187 -30 0 -47 17 -58 56 -4 15 -16 33 -28 41 -17 12 -23 11 -43 -5 -20 -16 -22 -24 -16 -57 10 -52 69 -111 119 -120 55 -11 121 17 152 63 24 35 25 44 25 187 0 154 -5 175 -40 175 -9 0 -21 -5 -28 -12z" fill="rgb(var(--locumate-primary-color))" />
                            <path
                                d="M1199 1857 c-55 -36 -69 -77 -69 -193 0 -88 3 -105 23 -134 36 -54 72 -75 127 -75 55 0 91 21 128 75 19 29 22 46 22 134 0 76 -4 110 -18 136 -25 50 -75 80 -132 80 -32 0 -58 -7 -81 -23z m129 -79 c20 -17 16 -197 -5 -220 -20 -22 -61 -23 -85 -1 -15 13 -18 32 -18 108 0 91 8 117 40 128 18 6 50 -1 68 -15z" fill="rgb(var(--locumate-primary-color))" />
                            <path
                                d="M1532 1868 c-8 -8 -12 -68 -12 -204 0 -158 3 -194 15 -204 21 -17 192 -9 223 11 28 17 62 79 62 111 0 13 -7 36 -15 52 -13 25 -13 33 2 76 15 42 15 51 2 86 -8 22 -29 48 -48 61 -29 20 -47 23 -125 23 -58 0 -96 -4 -104 -12z m179 -78 c21 -12 25 -50 7 -68 -7 -7 -36 -12 -65 -12 l-53 0 0 38 c0 21 3 42 7 45 10 11 82 8 104 -3z m13 -192 c20 -33 -4 -53 -68 -56 l-56 -3 0 41 0 41 56 -3 c41 -2 60 -8 68 -20z" fill="rgb(var(--locumate-primary-color))"/>
                            <path
                                d="M826 1357 c-38 -27 2 -95 42 -71 24 16 28 55 6 71 -10 7 -21 13 -24 13 -3 0 -14 -6 -24 -13z" fill="rgb(var(--locumate-primary-color))"/>
                            <path
                                d="M996 1354 c-19 -18 -21 -45 -4 -62 9 -9 110 -12 394 -12 334 0 385 2 398 16 21 20 20 30 -4 54 -19 19 -33 20 -394 20 -327 0 -377 -2 -390 -16z" fill="rgb(var(--locumate-primary-color))"/>
                            <path
                                d="M900 1175 c-10 -12 -10 -21 -2 -40 l12 -25 369 0 c360 0 371 1 381 20 8 14 8 26 0 40 -10 19 -21 20 -379 20 -319 0 -370 -2 -381 -15z" fill="rgb(var(--locumate-primary-color))"/>
                            <path d="M802 318 c-27 -27 -6 -68 35 -68 29 0 48 33 33 60 -12 22 -49 27 -68 8z" fill="rgb(var(--locumate-primary-color))"/>
                        </g>
                    </svg>
                </div>
                <div class="setting-item__content">

                    <div @click="links.subscribe">
                        <div class="setting-item__title"> Job Alerts</div>
                        <div class="setting-item__description">
                            Subscribe to Job Alerts
                        </div>
                    </div>
                </div>
                <div class="setting-item__link">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M7.42505 16.5999L12.8584 11.1666C13.5 10.5249 13.5 9.4749 12.8584 8.83324L7.42505 3.3999"
                            stroke="rgb(var(--locumate-clr-gray))" stroke-width="1.5" stroke-miterlimit="10"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                </div>
            </div>
            <div class="settings-separator mt-0"></div>
            <div class="d-flex justify-center">

                <el-button type="transparent" class="logout" @click="links.logout" data-testid="logout-btn">
                    <!-- <span class="locumate_icons locumate_icon-close"></span> -->
                    <div class="text_wrapper">
                        <div class="main_text">Logout</div>
                    </div>
                </el-button>
            </div>
        </div>

    </div>
    <el-drawer class="job-seeker-profile" custom-class="job-seeker-profile" direction="ttb" v-model="jobSeekerDrawer"
        :show-close="true" append-to-body="true">
        <div class="job-seeker-profile-wrapper">
          <div class="profile-top">
            <div class="image" v-if="user.image">
              <img :src="user.image" alt="profile" />
            </div>
            <div class="image" v-else>
             <el-avatar  :size="'large'" :shape="'square'" icon="el-icon-user-solid"></el-avatar>
           </div>
            <div class="details">
              <h3>{{ user.name ? user.name : 'N/A' }}</h3>

              <!-- <p>{{ $filters.userRoleConversion(user) }}</p> -->
               <p>{{ user.platformRole }}</p>
            </div>
          </div>
          <div>
            <div class="setting-item">
              <div class="setting-item__icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10 9.99996C12.3012 9.99996 14.1667 8.13448 14.1667 5.83329C14.1667 3.53211 12.3012 1.66663 10 1.66663C7.69885 1.66663 5.83337 3.53211 5.83337 5.83329C5.83337 8.13448 7.69885 9.99996 10 9.99996Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M16.0083 13.1167L13.0583 16.0667C12.9416 16.1834 12.8333 16.4 12.8083 16.5584L12.6499 17.6833C12.5916 18.0917 12.875 18.375 13.2833 18.3167L14.4083 18.1583C14.5666 18.1333 14.7916 18.025 14.9 17.9084L17.8499 14.9584C18.3583 14.45 18.5999 13.8583 17.8499 13.1083C17.1083 12.3667 16.5166 12.6083 16.0083 13.1167Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M15.5833 13.5416C15.8333 14.4416 16.5332 15.1416 17.4332 15.3916"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M2.84167 18.3333C2.84167 15.1083 6.05003 12.5 10 12.5C10.8667 12.5 11.7 12.625 12.475 12.8583"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>

              </div>
              <div class="setting-item__content" @click="links.changeJobSeekerAdditional">
                <div class="setting-item__title">
                  Account
                </div>
                <div class="setting-item__description">
                  Update your account settings
                </div>
              </div>
            </div>
            <div class="setting-item">
              <div class="setting-item__icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.75836 12.2501L9.00836 13.5001L12.3417 10.1667" stroke="rgb(var(--locumate-primary-color))"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M8.33335 5.00008H11.6667C13.3334 5.00008 13.3334 4.16675 13.3334 3.33341C13.3334 1.66675 12.5 1.66675 11.6667 1.66675H8.33335C7.50002 1.66675 6.66669 1.66675 6.66669 3.33341C6.66669 5.00008 7.50002 5.00008 8.33335 5.00008Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M13.3333 3.3501C16.1083 3.5001 17.5 4.5251 17.5 8.33343V13.3334C17.5 16.6668 16.6667 18.3334 12.5 18.3334H7.5C3.33333 18.3334 2.5 16.6668 2.5 13.3334V8.33343C2.5 4.53343 3.89167 3.5001 6.66667 3.3501"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>


              </div>
              <div class="setting-item__content" @click="links.goToPreviousApplications">
                <div class="setting-item__title">
                  Previous Jobs
                </div>
                <div class="setting-item__description">
                  View your previous jobs
                </div>
              </div>
            </div>
            <div class="setting-item">
              <div class="setting-item__icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M18.3334 8.33341V12.5001C18.3334 16.6667 16.6667 18.3334 12.5 18.3334H7.50002C3.33335 18.3334 1.66669 16.6667 1.66669 12.5001V7.50008C1.66669 3.33341 3.33335 1.66675 7.50002 1.66675H11.6667"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M18.3334 8.33341H15C12.5 8.33341 11.6667 7.50008 11.6667 5.00008V1.66675L18.3334 8.33341Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M5.83331 10.8333H10.8333" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M5.83331 14.1667H9.16665" stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <div class="setting-item__content" @click="links.goToTermsAndConditions">
                <div class="setting-item__title">
                  Terms & Conditions
                </div>
                <div class="setting-item__description">
                  View Terms & Conditions
                </div>
              </div>
            </div>
            <div class="setting-item">
              <div class="setting-item__icon">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M18.3084 15.2751C18.3084 15.5751 18.2417 15.8834 18.1001 16.1834C17.9584 16.4834 17.7751 16.7667 17.5334 17.0334C17.1251 17.4834 16.6751 17.8084 16.1667 18.0167C15.6667 18.2251 15.1251 18.3334 14.5417 18.3334C13.6917 18.3334 12.7834 18.1334 11.8251 17.7251C10.8667 17.3167 9.90842 16.7667 8.95842 16.0751C8.00008 15.3751 7.09175 14.6001 6.22508 13.7417C5.36675 12.8751 4.59175 11.9667 3.90008 11.0167C3.21675 10.0667 2.66675 9.11675 2.26675 8.17508C1.86675 7.22508 1.66675 6.31675 1.66675 5.45008C1.66675 4.88341 1.76675 4.34175 1.96675 3.84175C2.16675 3.33341 2.48341 2.86675 2.92508 2.45008C3.45841 1.92508 4.04175 1.66675 4.65841 1.66675C4.89175 1.66675 5.12508 1.71675 5.33341 1.81675C5.55008 1.91675 5.74175 2.06675 5.89175 2.28341L7.82508 5.00841C7.97508 5.21675 8.08341 5.40841 8.15841 5.59175C8.23341 5.76675 8.27508 5.94175 8.27508 6.10008C8.27508 6.30008 8.21675 6.50008 8.10008 6.69175C7.99175 6.88341 7.83341 7.08341 7.63341 7.28341L7.00008 7.94175C6.90841 8.03341 6.86675 8.14175 6.86675 8.27508C6.86675 8.34175 6.87508 8.40008 6.89175 8.46675C6.91675 8.53341 6.94175 8.58341 6.95842 8.63341C7.10842 8.90841 7.36675 9.26675 7.73341 9.70008C8.10841 10.1334 8.50841 10.5751 8.94175 11.0167C9.39175 11.4584 9.82508 11.8667 10.2667 12.2417C10.7001 12.6084 11.0584 12.8584 11.3417 13.0084C11.3834 13.0251 11.4334 13.0501 11.4917 13.0751C11.5584 13.1001 11.6251 13.1084 11.7001 13.1084C11.8417 13.1084 11.9501 13.0584 12.0417 12.9667L12.6751 12.3417C12.8834 12.1334 13.0834 11.9751 13.2751 11.8751C13.4667 11.7584 13.6584 11.7001 13.8667 11.7001C14.0251 11.7001 14.1917 11.7334 14.3751 11.8084C14.5584 11.8834 14.7501 11.9917 14.9584 12.1334L17.7167 14.0917C17.9334 14.2417 18.0834 14.4167 18.1751 14.6251C18.2584 14.8334 18.3084 15.0417 18.3084 15.2751Z"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-miterlimit="10" />
                  <path
                    d="M15.4167 7.50016C15.4167 7.00016 15.025 6.2335 14.4417 5.6085C13.9083 5.0335 13.2 4.5835 12.5 4.5835"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M18.3333 7.50008C18.3333 4.27508 15.725 1.66675 12.5 1.66675"
                    stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>

              </div>
              <div class="setting-item__content">
                <a
            :href="supportLink"
            target="_blank"
            data-testid="support-btn"
          >
                <div class="setting-item__title">
                  Support Team
                </div>
                <div class="setting-item__description">
                  Get connected with the Support Team
                </div>
                </a>
              </div>
            </div>
          </div>
          <el-button class="text-only logout-btn" @click="links.logout">
            LOGOUT
          </el-button>
        </div>
      </el-drawer>
</template>
<script>
import { onMounted, inject, ref, computed } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
    "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonTitle } from "@ionic/vue";
import { ElMessageBox } from "@/components/Vendor/Element";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { isUSRegion } from '@/helpers/region/regionHelper.js';
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
export default {
    components: {
        IonToolbar,
        IonTitle
    },
    setup() {
        const $router = useRouter();
        const $store = useStore();
        const setPageClassGlobal = inject("setPageClassGlobal");

        const mainMenuShow = inject("mainMenuShow");
        let supportLink = ref(null);
        const user = $store.getters.GET_USER_DATA;
        const isAustralia = isAustraliaRegion();
        const isUS = isUSRegion();
        const jobSeekerDrawer = ref(false);
        const regex = /http:\/\/|https:\/\//gm;
        supportLink.value = user.supportSite.replace(regex, "");
        supportLink = `https://${supportLink.value}`;
        const links = {
            changeJobSeekerAdditional: () => {
                $router.push({
                    name: "additional_profile_job_seeker",
                });
            },
            changeBasicProfileJobSeeker: () => {
                $router.push({
                    name: "basic_profile_job_seeker",
                });
            },
            changePhoto: () => {
                $router.push({
                    name: "profile_photo_job_seeker",
                });
            },
            notifications: () => {
                $router.push({
                    name: "profile_notifications",
                });
            },
            goToAbout: () => {
                const link = document.getElementById("goToAboutPage");
                link.click();
            },
            goToPreviousApplications: () => {
              $router.push({
                name: "job_seeker_previous_applications",
              });
            },
            goToTermsAndConditions: () => {
                $router.push({
                    name: "terms_and_conditions",
                });
            },
            goToPrivacyPolicy: () => {
              
                if(isAustralia.value){
                $router.push({
                                  name: "privacy_policy",
                              });
                }else{
                  window.open("https://healthshifts.ai/privacy-policy/", "_blank");

                }
            },

            logout: () => {
                (async () => {
                    try {
                        await ElMessageBox.confirm(
                            ``,
                            "Are you sure you want to log out?",
                            {
                                distinguishCancelAndClose: true,
                                showConfirmButton: true,
                                confirmButtonText: "Logout",
                                cancelButtonText: "Cancel",
                                confirmButtonClass: "el-button--green",
                                cancelButtonClass: "el-button--grey",
                                showClose: true,
                            }
                        );
                    } catch {
                        return;
                    }
                    try {
                        await $store.dispatch("AUTH_LOGOUT");
                    } catch (error) {
                        console.log(error);
                    }
                })();
            },
            subscribe: () => {
                $router.push({
                    name: "subscribe_jobs",
                });
            },
        };

        onMounted(() => {
            setPageClassGlobal("global_profile_job_seeker_setting_page");
            mainMenuShow(true);
        });

        const unreadNotifications = computed(() => {
        return $store.getters.GET_NOTIFICATIONS_DATA.unread;
      });
      
      
        const notifications = () => {
          $router.push({
            name: "notifications",
          });
        }

        return {
            links,
            supportLink,
            isUS,
            isAustralia,
            jobSeekerDrawer,
            user,
            unreadNotifications,
            notifications
        };
    },
};
</script>
